<!-- 批售出库 -->
<template>
  <article class="out_bound">
    <group :title="list.title" v-for="(list, index) in inputLists" :key="index">
      <x-input
        v-if="index === 0"
        v-model="dealerType['key']"
        placeholder="请选择"
        :readonly="true"
        @click.native="showSub"
        is-link>
        <div slot="label"><span class="red_dots">*</span>批售对象</div>
      </x-input>
      <x-input
        v-for="item in list.value" :key="item.name"
        v-model="formData[item.name]"
        :name="item.name"
        :placeholder="item.placeholdor"
        :required="item.required"
        :keyboard="item.type"
        :is-type="item.validate"
        :max="11"
        :class="{'price-verify': item.verify}">
        <div slot="label">
          <span class="red_dots" v-if="item.required">*</span>{{item.title}}
        </div>
        <span slot="right">{{item.unit}}</span>
      </x-input>
      <x-input
        v-if="index === 2"
        v-model="calculateData['car_gross_profit']"
        title="成交毛利"
        placeholder=""
        :readonly="true">
        <span slot="right">元</span>
      </x-input>
      <datetime
        v-if="index === 2"
        v-model="formData.transaction_date"
        title="成交日期"
        placeholder="请选择日期"
        confirm-text="确定"
        cancel-text="取消"
        inline-desc="*"
        @on-change="change"
        class="deal_date">
      </datetime>
    </group>
    <group title="备注">
      <x-textarea
        v-model="formData.remark"
        :max="255"
        :show-counter="true"
        name="detail"
        placeholder="请输入内容（非必填）">
      </x-textarea>
    </group>
    <upload-pic
      :images.sync="formData.images"
      :show-name="imagesConfig.showName"
      :dragable="imagesConfig.dragable"
      :count="imagesConfig.length"
      @upload="ImgUpload"
      @delete="ImgDelete">
      <p class="title">{{imagesConfig.title}}</p>
    </upload-pic>
    <!-- 批售对象弹窗 -->
    <popup v-model="showNoScroll" style="height: 100%;overflow: auto;">
      <group title="批售对象">
        <radio
          class="single_select_rule"
          v-model="formData.dealer_type"
          :options="batchList"
          @on-change="changeBatch">
        </radio>
      </group>
      <section class="data_state">
        <p>说明：</p>
        <p>“立新车市的有效车商”，是指在“立新车市”上有注册，并且必须具备竞拍资格的车商定义为“立新车市的有效车商”。所以，在立新车市有注册过，但一直以来从未缴纳过2000元以上保证金的车商、以及因为积分落后或围标等行为而被淘汰清除出局的车商都不是“立新车市的有效车商。</p>
      </section>
    </popup>
    <footer-btn title="提交" :isReady="!allValidate" @submit="onSubmit()"></footer-btn>
    <!-- 价格提醒 begin-->
    <x-alert v-model="dialogShow" button-text="我知道了" title="金额防错提示" class="verify-dialog">
      <h4 class="tips">当前的单位为“元”，你所输入的以下金额小于100元，请确认金额输入是否正确。</h4>
      <p v-for="(item, index) in dialogContent" :key="index">{{item}}</p>
    </x-alert>
    <!-- 价格提醒 end -->
  </article>
</template>
<script>
import { Group, XTextarea, Datetime, XInput, Popup, Radio, XAlert, UploadPic } from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'
import cache from '../../common/cache'
import util from '../../common/util'
import { Decimal } from 'decimal.js'
export default {
  components: {
    Group,
    XTextarea,
    Datetime,
    XInput,
    UploadPic,
    Popup,
    Radio,
    FooterBtn,
    XAlert
  },
  data() {
    return {
      dialogShow: false,
      isVerify: true, // 是否执行金额验证
      dialogContent: [], // 提示文本
      carId: '',
      showNoScroll: false, // 是否展示批售对象弹窗
      batchList: [
        { key: 'other', value: '其他平台' },
        { key: 'non_lixin', value: '非立新车市车商' },
        { key: 'lixin', value: '立新车市的有效车商' }
      ],
      inputLists: [],
      validForm: { // 需验证的必填项
        dealer_type: false,
        buyer_name: false,
        buyer_mobile: false,
        car_cost: false,
        car_income: false,
        transaction_date: false
      },
      formData: {
        dealer_type: '', // 批售对象
        dealer_name: '', // 名称
        buyer_name: '',
        buyer_mobile: '',
        car_cost: '', // 车辆成本/收车合同价
        car_income: '', // 车辆收入/水平总收入/成交价格
        transaction_date: '',
        remark: '',
        images: []
      },
      priceKeys: ['car_cost', 'car_income'], // 集中单位处理
      imagesConfig: {
        requestUrl: 'getImageByAuction',
        showName: false,
        dragable: false,
        title: '凭证照片（如合同、收款信息、买家身份证等）',
        length: 10
      }
    }
  },
  created() {
    this.inputLists = [
      { title: '客户信息',
        value: [{
          title: '名称', // 标题名
          name: 'dealer_name', // input属性name
          placeholdor: '平台名称或车商企业名称', // placeholdor
          unit: '', // 单位
          type: 'text', // 输入类型
          validate: '', // 校验规则
          required: false // 是否必填
        }, {
          title: '买家姓名',
          name: 'buyer_name',
          placeholdor: '请输入',
          unit: '',
          type: 'text',
          validate: this.val_owner_name,
          required: true
        }, {
          title: '买家电话',
          name: 'buyer_mobile',
          placeholdor: '请输入',
          unit: '',
          type: 'number',
          validate: this.val_owner_mobile,
          required: true
        }]
      }, {
        title: '收车成本',
        value: [{
          title: '收车合同价',
          name: 'car_cost',
          placeholdor: '请输入',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }]
      }, {
        title: '批售情况',
        value: [{
          title: '成交价格',
          name: 'car_income',
          placeholdor: '请输入',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }]
      }
    ]
    let lastFormData = cache.getSessionData('OUTBOUND_FROM_DATA')
    this.carId = this.$route.params.id
    if (lastFormData) {
      this.formData = this.getFormatData(lastFormData)
      this.validForm.transaction_date = true
    } else {
      this.$rest.auction.getVehicleCarDetail(null, this.carId).then((res) => {
        if (res.code === 0) {
          let price = res.data.contract_price
          if (price) {
            this.formData.car_cost = new Decimal(price).div(100).toNumber()
          }
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  computed: {
    dealerType() {
      let val = this.formData.dealer_type
      let item = this.batchList.find(v => {
        return v.key === val
      })
      let value = item ? item.value : ''
      return { key: value }
    },
    calculateData() {
      let carGrossProfit = ''
      if (this.validForm.car_income && this.validForm.car_cost) {
        carGrossProfit = new Decimal(+this.formData.car_income).minus(+this.formData.car_cost).toNumber()
      }
      return { car_gross_profit: carGrossProfit }
    },
    allValidate () {
      let isValid = true
      let keys = Object.keys(this.validForm)
      let values = Object.values(this.validForm)
      // 判断必填项是否有值
      for (let i = 0, len = keys.length; i < len; i++) {
        if (!this.formData[keys[i]]) {
          isValid = false
          break
        }
      }
      // 校验必填项
      for (let i = 0, len = values.length; i < len; i++) {
        if (!values[i]) {
          isValid = false
          break
        }
      }
      return isValid
    }
  },
  methods: {
    getFormatData(data) {
      this.priceKeys.forEach(v => {
        data[v] = (data[v] / 100).toFixed(2)
      })
      // data.images = data.images.map(v => {
      //   return v.src
      // })
      return data
    },
    postData() {
      let formatData = {}
      this.priceKeys.forEach(v => {
        let value = +this.formData[v]
        formatData[v] = new Decimal(value).mul(100).toNumber()
      })
      if (this.formData.images.length > 0) {
        formatData.images = this.formData.images.map(v => {
          return { code: 'other', src: v.src }
        })
      }
      let params = { ...this.formData, ...formatData }
      this.$rest.outBound.postBatchSale(params, this.carId).then(res => {
        if (res.code === 0) {
          this.$router.push(`/outbound/succ/${res.data.id}`)
        } else {
          this.showToast(res.message)
        }
      })
    },
    val_price(val, name) {
      let valid = util.regexpMap.regexp_price.test(val)
      let result = this.validate(valid, '请输入有效的价格，小数点最多保留两位')
      this.validForm[name] = valid // 即时存储表单校验结果
      if (!result.valid) {
        this.showToast(result.msg)
      }
      // 组件input的isType自定义函数，需要返回包含布尔值valid和msg这两个属性的对象
      return result
    },
    val_owner_name(val, name) {
      // 校验车主姓名，可以是企业名称，限制为字符长度60
      let byteLength = util.getByteLen(val)
      let valid = (byteLength >= 4 && byteLength <= 60)
      this.validForm[name] = valid // 即时存储表单校验结果
      return this.validate(valid, '请输入有效的联系人名字')
    },
    val_owner_mobile(val, name) {
      let valid = util.regexpMap.regexp_mobile.test(val)
      this.validForm[name] = valid // 即时存储表单校验结果
      return this.validate(valid, '请输入有效的电话号码')
    },
    validate(valid, msg) {
      return { valid: valid, msg: msg }
    },
    changeBatch(val) { // 关闭弹床
      if (val) this.showNoScroll = false
    },
    showSub() { // 弹出批售对象弹窗
      this.showNoScroll = true
    },
    change(val) {
      this.validForm.transaction_date = true
    },
    onSubmit() {
      if (this.allValidate) {
        if (this.isVerify) {
          const ispass = this.priceVerify()
          if (!ispass) {
            return false
          }
        }
        this.postData()
      } else {
        this.showToast('请将必填信息填写完整后再提交')
      }
    },
    // 金额防错提示
    priceVerify() {
      if (this.formData.car_cost < 100) {
        this.toggleVerify('car_cost')
        this.dialogContent.push(`收车合同价：${this.formData.car_cost}元`)
      }
      if (this.formData.car_income < 100) {
        this.toggleVerify('car_income')
        this.dialogContent.push(`成交价格：${this.formData.car_income}元`)
      }
      if (this.dialogContent.length > 0) {
        this.dialogShow = true
        this.isVerify = false
        return false
      }
      return true
    },
    toggleVerify(name) {
      for (let i = 0, len = this.inputLists.length; i < len; i++) {
        const obj = this.inputLists[i]
        for (let j = 0, length = obj.value.length; j < length; j++) {
          const item = obj.value[j]
          if (item.name === name) {
            this.inputLists[i].value[j].verify = true
            break
          }
        }
      }
    },
    ImgUpload(i) {
      let iamges = this.formData.images
      this.$wechat.imgUpLoad(this, i, iamges, this.imagesConfig.requestUrl)
    },
    ImgDelete(i) {
      let iamges = this.formData.images
      this.$wechat.imgDelete(i, iamges)
    }
  },
  watch: {
    'formData.dealer_type' (val) {
      if (val) this.validForm.dealer_type = true
    }
  }
}

</script>
<style lang="less">
@import '../../stylesheets/base/fn';
@import '../../stylesheets/base/mixin/common.less';
.out_bound {
  .weui_cell_hd{width: 210/@w2;}
  .deal_date {
    .weui_cell_bd{
      width: 210/@w2;
      overflow: hidden;
      p{display: inline-block;}
    }
    .vux-label-desc {
      color: red;
      float: left;
    }
  }
  .red_dots{color: red;}
}

.data_state {
  padding: 30/@w2;
  color: #ababab;
  font-size: 30/@w2;
}

</style>
